import { EditOutlined } from "@ant-design/icons";
import { css } from "@linaria/core";
import { Button } from "antd";

const hiddenSpacer = css`
  visibility: hidden;
`;

// Invisible stand-in for the row action button, so price amounts right-align
// in rows (and the summary) that have no button.
export const PriceButtonSpacer = () => <Button className={hiddenSpacer} disabled icon={<EditOutlined />} />;
